import { FormikHelpers, useFormik } from 'formik';
import { HomeEdit, Home } from '../home';
import {
  Grid,
  TextField,
  Box,
  FormHelperText,
  Paper,
  Button,
} from '@mui/material';
import { getMediaUrl } from '../../../core/utils/image';

type HomeProps = {
  onSubmit: (
    value: HomeEdit,
    helpers: FormikHelpers<HomeEdit>
  ) => Promise<void>;
  submitting: boolean;
  home: Home;
};

const EditHomeForm = ({ onSubmit, submitting, home }: HomeProps) => {
  const handleSubmit = async (
    value: HomeEdit,
    helpers: FormikHelpers<HomeEdit>
  ) => {
    await onSubmit(value, helpers);
  };

  const initialValues: HomeEdit = {
    title: home.title,
    link: home.link,
    base64Img: home.base64Img,
    imageAlt: home.imageAlt || '',
    image: null,
  };

  const formik = useFormik({
    initialValues,
    onSubmit: handleSubmit,
  });

  // console.log('Edit Form', initialValues);

  return (
    <>
      <Box sx={{ flexGrow: 1, maxWidth: 800 }}>
        <form onSubmit={formik.handleSubmit}>
          <Grid container spacing={1}>
            <Grid item>
              <Paper sx={{ p: 2, pb: 3 }}>
                <Grid
                  container
                  justifyContent="space-between"
                  spacing={1}
                  sx={{ mt: 2 }}
                >
                  <Grid item alignSelf="flex-start" sx={{ flexGrow: 1 }}>
                    <TextField
                      fullWidth
                      name="title"
                      size="small"
                      type="text"
                      variant="outlined"
                      label="Title"
                      placeholder=""
                      value={formik.values.title}
                      onChange={formik.handleChange}
                      error={Boolean(formik.errors.title)}
                      helperText={formik.errors.title}
                    />
                  </Grid>
                </Grid>
                <Grid
                  container
                  justifyContent="space-between"
                  spacing={1}
                  sx={{ mt: 2 }}
                >
                  <Grid item alignSelf="flex-start" sx={{ flexGrow: 1 }}>
                    <TextField
                      fullWidth
                      name="imageAlt"
                      size="small"
                      type="text"
                      variant="outlined"
                      label="Image Alt"
                      placeholder=""
                      value={formik.values.imageAlt}
                      onChange={formik.handleChange}
                      error={Boolean(formik.errors.imageAlt)}
                      helperText={formik.errors.imageAlt}
                    />
                  </Grid>
                </Grid>
                <Grid
                  container
                  justifyContent="space-between"
                  spacing={1}
                  sx={{ mt: 2 }}
                >
                  <Grid item alignSelf="flex-start" sx={{ flexGrow: 1 }}>
                    <TextField
                      fullWidth
                      name="link"
                      size="small"
                      type="text"
                      variant="outlined"
                      label="Link"
                      placeholder=""
                      value={formik.values.link}
                      onChange={formik.handleChange}
                      error={Boolean(formik.errors.link)}
                      helperText={formik.errors.link}
                    />
                  </Grid>
                </Grid>
                <Grid
                  container
                  justifyContent="space-between"
                  spacing={1}
                  sx={{ mt: 2 }}
                >
                  <Grid item alignSelf="flex-start" sx={{ flexGrow: 1 }}>
                    <TextField
                      fullWidth
                      name="base64Img"
                      size="small"
                      type="text"
                      variant="outlined"
                      label="Base64 Image"
                      placeholder=""
                      value={formik.values.base64Img}
                      onChange={formik.handleChange}
                      error={Boolean(formik.errors.base64Img)}
                      helperText={formik.errors.base64Img}
                    />
                  </Grid>
                </Grid>
                <Grid
                  container
                  justifyContent="space-between"
                  spacing={1}
                  sx={{ mt: 2 }}
                >
                  <Grid item alignSelf="flex-start" sx={{ flexGrow: 1 }}>
                    <Grid item xs={12}>
                      Image
                    </Grid>

                    <Grid item sx={{ mr: 3 }}>
                      <img
                        src={getMediaUrl(
                          home.media.length ? home.media[0] : null
                        )}
                        width="256px"
                        alt="cover"
                      />
                    </Grid>
                    <Box>
                      <input
                        type="file"
                        onChange={({ target: { files } }) => {
                          formik.setFieldValue(
                            'image',
                            files && files.length ? files[0] : null
                          );
                        }}
                        name="image"
                      />
                    </Box>
                    {formik.touched.image && formik.errors.image && (
                      <FormHelperText error>
                        {formik.errors.image}
                      </FormHelperText>
                    )}
                  </Grid>
                </Grid>

                <Grid container sx={{ mt: 2 }}>
                  <Button
                    type="submit"
                    variant="contained"
                    disabled={submitting}
                    size="small"
                  >
                    {submitting ? 'Saving' : 'Save'}
                  </Button>
                </Grid>
              </Paper>
            </Grid>
          </Grid>
        </form>
      </Box>
    </>
  );
};

export default EditHomeForm;
